import { generateApiPath } from "@routes/generatePath.ts";
import type { IExtractApiParams } from "@routes/types.ts";

const pathBase = `/family-illnesses/`;
const pathById = `${pathBase}:familyIllnessesId/`;

type IPathByIdParams = IExtractApiParams<typeof pathById>;

export const familyIllnesses = {
  getAll: () => generateApiPath(pathBase),
  post: () => generateApiPath(pathBase),
  put: (params: IPathByIdParams) => generateApiPath(pathById, params),
  delete: (params: IPathByIdParams) => generateApiPath(pathById, params),
};
